import { useGetBhajansQuery } from "./bhajansApiSlice"
import Bhajan from "./Bhajan"
import useAuth from "../../hooks/useAuth"
import useTitle from "../../hooks/useTitle"
import { Spinner } from "react-bootstrap"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"


const BhajanList = () => {
    useTitle('Nirakar Satgur: Bhajans List')

    const { id, isManager, isAdmin } = useAuth()
    const {pageNumber} = useSelector((state)=> state?.bhajan)
    const {
        data: bhajans,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetBhajansQuery(pageNumber,{   
        refetchOnFocus: false,
        refetchOnMountOrArgChange: true
    });
    
    console.log('bhajan=>>',bhajans)
    let content

    if (isLoading) content = <Spinner color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess) {
        const { ids, entities } = bhajans

        let filteredIds
        if (isManager || isAdmin) {
            filteredIds = [...ids]
        } else {
            filteredIds = ids.filter(bhajanId => entities[bhajanId].createdBy === id)
        }

        const tableContent = ids?.length && filteredIds.map((bhajanId,index) => <Bhajan key={bhajanId} bhajanId={bhajanId} index={index} />)

        content = (
            <>
            <div className="flex justify-between ">
                <h2 className="pageHeading">Bhajan List</h2>
                <Link className="btn btn-primary mb-20" to='/dashboard/bhajans/new'>Add New Bhajan</Link>
            </div>
            <table className="table table--notes">
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th note__status">S.No.</th>
                        <th scope="col" className="table__th note__created">Title</th>
                        <th scope="col" className="table__th note__created">Author</th>
                        <th scope="col" className="table__th note__edit">Edit</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table></>
        )
    }

    return content
}
export default BhajanList